// mbscan manager-client の同名ファイルと共通。ただし mbfab のバックエンドは IDENTITY_NOT_FOUND を返さないため、その分類は持たない
import type { GraphqlErrorClassification } from './apollo/error-classification'

// エラー分類 → ErrorPanel に出す既定の文言とボタン種別の対応表（エラー表示の文言の正本）。
// 以前は各画面が文言を手書きしており、同じ状況でも「再試行 / 再取得 / 再確認」
// 「このページにはアクセスできません / 権限がありません / アクセス権限がありません」のように揺れていた。
// 画面固有の事情（運営メンバー限定など）がある場合だけ、呼び出し側で description 等を上書きする

/** ボタンの種別。sign-out は /sign_out でセッションを破棄してから再ログインさせる */
export type ErrorPanelActionKind = 'sign-out' | 'retry'

export type ErrorPanelCopy = {
  title: string
  description: string
  action: { kind: ErrorPanelActionKind; label: string } | null
}

export const ERROR_PANEL_ACTION_LABELS = {
  retry: '再試行',
  signIn: 'ログインし直す',
} as const

export function errorPanelCopy(
  classification: GraphqlErrorClassification,
  {
    subject,
    canRetry,
  }: {
    /** 取得しようとしたもの（「ミルシート一覧」「このページ」等）。タイトルに埋め込む */
    subject: string
    canRetry: boolean
  },
): ErrorPanelCopy {
  const retry = canRetry ? { kind: 'retry' as const, label: ERROR_PANEL_ACTION_LABELS.retry } : null
  switch (classification) {
    case 'unauthenticated':
      // /sign_in だと Auth0 のローカルセッションが生きている限り同じトークンで戻ってきて堂々巡りになるため、
      // 再ログインは必ず /sign_out 経由にする
      return {
        title: 'ログインの有効期限が切れました',
        description: 'お手数ですが、もう一度ログインしてください。',
        action: { kind: 'sign-out', label: ERROR_PANEL_ACTION_LABELS.signIn },
      }
    case 'forbidden':
      // 権限は管理者の操作で戻ることがあるため、再試行できる画面では再試行を残す
      return {
        title: `${subject}にはアクセスできません`,
        description: 'ログイン状態と権限を確認してください。',
        action: retry,
      }
    case 'bad-user-input':
    case 'unexpected':
      return {
        title: `${subject}を取得できませんでした`,
        description: 'しばらくしてから再度お試しください。',
        action: retry,
      }
  }
}
